import type { Column } from '@/components/ui/DataTable'
import { Chip } from '@/components/ui/Chip'
import { FavoriteToggle } from '@/components/review/FavoriteToggle'
import { COPY_TYPES } from '@/lib/constants'
import { shortDate } from '@/lib/format'
import type { CopyDoc } from '@/types'

export function buildColumns({
  onFavorite,
}: {
  onFavorite: (id: string, favorite: boolean) => void
}): Column<CopyDoc>[] {
  return [
    {
      key: 'favorite',
      header: '',
      width: '36px',
      render: (d) => (
        <FavoriteToggle favorite={d.favorite} onChange={(next) => onFavorite(d.id, next)} />
      ),
    },
    {
      key: 'name',
      header: 'Name',
      sortBy: (d) => d.name,
      render: (d) => <span className="font-head text-[13px] font-semibold">{d.name}</span>,
    },
    {
      key: 'type',
      header: 'Type',
      width: '130px',
      sortBy: (d) => d.copyType,
      render: (d) => (
        <span className="text-ink-muted">
          {COPY_TYPES.find((t) => t.value === d.copyType)?.label ?? d.copyType}
        </span>
      ),
    },
    {
      key: 'version',
      header: 'Version',
      width: '80px',
      sortBy: (d) => d.version,
      render: (d) => <span className="tabular text-ink-muted">v{d.version}</span>,
    },
    {
      key: 'updated',
      header: 'Modified',
      width: '110px',
      sortBy: (d) => d.updatedAt,
      render: (d) => <span className="text-ink-muted">{shortDate(d.updatedAt)}</span>,
    },
    {
      key: 'author',
      header: 'By',
      width: '100px',
      sortBy: (d) => d.author,
      render: (d) => <span className="text-ink-muted">{d.author}</span>,
    },
    {
      key: 'tags',
      header: 'Tags',
      width: '170px',
      render: (d) => (
        <span className="flex flex-wrap gap-1">
          {d.tags.slice(0, 2).map((t) => (
            <Chip key={t} label={t} />
          ))}
        </span>
      ),
    },
  ]
}
